import React from 'react';
import { SvgProps } from 'react-native-svg';
import { ICONS, IconName, IconVariant } from './registry';

type Props<N extends IconName> = {
  name: N;
  // (string & {}) trick: preserves per-icon variant autocomplete in literal calls
  // while accepting any string when name is dynamic (registry has runtime fallback)
  variant?: IconVariant<N> | (string & {});
  size?: number;
  color?: string;
} & Omit<SvgProps, 'color'>;

export function Icon<N extends IconName>({
  name,
  variant,
  size = 20,
  color,
  width,
  height,
  ...rest
}: Props<N>) {
  const entry = ICONS[name];
  if (!entry) {
    console.warn(`[Icon] Unknown icon name: "${name}"`);
    return null;
  }
  const key = (variant ?? 'default') as keyof typeof entry;
  const Svg = (entry[key] ?? entry.default) as React.FC<SvgProps>;
  const colorProps = color ? { color, fill: color } : {};
  return (
    <Svg
      width={width ?? size}
      height={height ?? size}
      {...colorProps}
      {...rest}
    />
  );
}

export default Icon;
